import React from 'react';
import { ZinantisServiceState } from '../../../types/zitoneoServicesTypes';
import ServiceException from './ServiceException';
import { useZitoneoServices } from '../../../contexts/ZitoneoContentContext';
import TextInput from '../../../../../muiComponents/TextInput/TextInput';
import ServiceAttributes from './ServiceAttributes';

interface ZitoneoServiceInstanceProps {
    hotelService: ZinantisServiceState;
    isDisabled: boolean;
}

const ZitoneoServiceInstance = (props: ZitoneoServiceInstanceProps) => {
    const { hotelService, isDisabled } = props;
    const {
        handleChangeAttributeValue,
        handleDeleteAttributeValue,
        handleEditServiceContent,
    } = useZitoneoServices();

    const handleChange = (
        id: string,
        value: string,
        idService: string,
        idAttributeDefinition: number
    ) => {
        handleChangeAttributeValue(idService, idAttributeDefinition, id, value);
    };

    const handleDelete = (id: string, idService: string) => {
        handleDeleteAttributeValue(idService, id);
    };

    return (
        <div className='flex-column gap-30'>
            {hotelService.Exceptions.length ? (
                <div className='flex-column gap-30'>
                    {hotelService.Exceptions.map(exception => (
                        <ServiceException
                            key={exception.Id}
                            idHotelService={hotelService.Id}
                            exception={exception}
                            isDisabled={isDisabled}
                        />
                    ))}
                </div>
            ) : (
                ''
            )}
            <TextInput
                labelText={'description2'}
                deleteIcon={false}
                value={hotelService.Description ?? ''}
                multiline
                rows={3}
                disabled={isDisabled}
                sx={{
                    backgroundColor: 'var(--background)',
                    paddingBlock: '16px',
                }}
                labelProps={{
                    sx: {
                        backgroundColor: 'var(--background) !important',
                        padding: '0 4px',
                    },
                }}
                handleChange={(_e: unknown, newValue: string) => {
                    handleEditServiceContent(
                        hotelService.Id,
                        'Description',
                        newValue
                    );
                }}
            />
            <ServiceAttributes
                serviceId={hotelService.Id}
                attributeDefinitions={hotelService.AttributeDefinitions}
                attributeValues={hotelService.AttributeValues}
                disabled={isDisabled}
                onChange={handleChange}
                onDelete={handleDelete}
            />
        </div>
    );
};

export default ZitoneoServiceInstance;
